import React, { Component } from 'react';
import { withTranslation, WithTranslation, Trans } from 'react-i18next';

import _ from 'lodash';

import integrationsService from '../../services/integrations-service';
import mapleService from '../../services/maple-integration-service';
import { formatDate } from '../../utils/date-helpers';
import { generateKey } from '../../utils/utils';
import AppView from '../layouts/AppView';
import Text from '../shared/Typography';
import Button from '../shared/Button';
import Section from '../shared/PageSection';
import Card from '../shared/Card';

type IntegrationType = {
  created_at: string,
  integration: {
    name: string
  }
}

type State = {
  integrations: IntegrationType[],
  possibleIntegrations: IntegrationType[],
  loadingMyIntegrations: boolean,
  loadingAllIntegrations: boolean,
  loading: boolean,
}

type Props = WithTranslation
class UserEdit extends Component<Props, State> {
  state: State = {
    integrations: [],
    possibleIntegrations: [],
    loading: true,
    loadingAllIntegrations: true,
    loadingMyIntegrations: true
  };
  props: Props;

  componentWillMount() {
    integrationsService.getIntegrations().then((response) => {
      this.setState({
        integrations: response.integrations,
        loadingMyIntegrations: false,
        loading: this.state.loadingAllIntegrations // depends on if the other is still loading
      });
    });
    integrationsService.getAllIntegrations().then((response) => {
      this.setState({
        possibleIntegrations: response.integrations,
        loadingAllIntegrations: false,
        loading: this.state.loadingMyIntegrations // depends on if the other is still loading
      });
    });
  }

  connect(integrationName) {
    if (integrationName === 'maple') {
      mapleService.connectToMaple(this.state.user);
    }
  }

  disconnectFromMaple = (integrationId: number) => {
    mapleService.disconnectFromMaple(integrationId).then((response) => {
      const integrations = this.state.integrations.slice();
      const index = integrations.findIndex((t) => t.id === response.user_integration.id);
      integrations.splice(index, 1);
      this.setState({
        integrations
      });
    });
  };

  getIntegrationDescription(integrationName, t) {
    const integrationDate = this.state.integrations.find((integration) => (
      integration.integration.name === integrationName)).created_at;
    const descriptions = {
      default: t('connected_since', { date: formatDate(integrationDate) }),
      caredove: t('caredove')
    };
    return descriptions[integrationName] || descriptions.default;
  }

  getIntegrationPrompt(integrationName, t) {
    return {
      maple: t('maple')
    }[integrationName];
  }

  render() {
    const { t } = this.props;
    const unconnectedIntegrations = this.state.possibleIntegrations.filter((integration) => {
      return !this.state.integrations.find((i) => i.integration.name === integration.name);
    });
    return (
      <AppView viewType='private-body' pageClassName='user-profile'>
        <Section title={t('integrations')} icon='profile-illo' iconSize='large'>
          <main className=''>
            {this.state.integrations.map((integration) => {
              return (
                <div key={integration.id}>
                  <Card
                    className='integration-card'
                  >
                    <Text h2>{_.startCase(integration.integration.name)}</Text>
                    <div className='integration-card__body'>
                      <Text paragraph className='integration-prompt__copy'>
                        {this.getIntegrationDescription(integration.integration.name, t)}
                      </Text>
                      {integration.integration.name.toLowerCase() === 'maple' &&
                        <Button onClick={() => this.disconnectFromMaple(integration.id)}>{t('disconnect')}</Button>
                      }
                    </div>
                  </Card>
                </div>
              );
            })}
            {unconnectedIntegrations.map((integration) => {
              return (
                <Card className='integration-prompt' key={generateKey('unconnected')}>
                  <Text h2>
                    <Trans i18nKey='connect_to' t={t}>{{ name: _.startCase(integration.name) }}</Trans>
                  </Text>
                  <Text className='integration-prompt__copy' paragraph>
                    {this.getIntegrationPrompt(integration.name, t)}
                  </Text>
                  <Button
                    className='btn is-primary'
                    onClick={() => this.connect(integration.name)}
                    label={t('connect')}
                  />
                </Card>
              );
            })}
          </main>
        </Section>
      </AppView>
    );
  }
}

export default withTranslation('integrations')(UserEdit);



// WEBPACK FOOTER //
// ./src/components/pages/integrations.js